import React from 'react';
import { StickyProvider } from 'contexts/app/app.provider';
import SEO from 'components/seo';
import Layout from 'components/layout';
import Banner from 'sections/banner';
import KeyFeature from 'sections/key-feature';
import ServiceSection from 'sections/service-section';
import Feature from 'sections/feature';
import CoreFeature from 'sections/core-feature';
import WorkFlow from 'sections/workflow';
import Package from 'sections/package';
import TeamSection from 'sections/team-section';
import TestimonialCard from 'sections/testimonial';
import BlogSection from 'sections/blog-section';
import Subscribe from 'sections/subscribe';
import WhatsAppWidget from 'react-whatsapp-widget'
import { Box } from 'theme-ui';

// Load other package css file
import 'react-multi-carousel/lib/styles.css';
import 'react-modal-video/css/modal-video.min.css';
import 'rc-drawer/assets/index.css';
import 'react-whatsapp-widget/dist/index.css'
import { FaPhone } from 'react-icons/fa';

export default function IndexPage() {
  return (<>
    <StickyProvider>
      <Layout>
        <SEO lang="ar" dir="rtl" />
        <Banner />
        <KeyFeature />
        {/* <ServiceSection /> */}
        <Feature />
        <CoreFeature />
        {/* <WorkFlow /> */}
        {/* <Package /> */}
        {/* <TeamSection /> */}
        <TestimonialCard />
        {/* <BlogSection /> */}
        {/* <Subscribe /> */}
        <Box sx={styles.widget.box}>
          <a href='tel:0550474803' className="_1bpcM"><FaPhone /> </a>
          <WhatsAppWidget
            phoneNumber='9660550474803'
            textReplyTime='عادة ما يتم الرد خلال ساعة'
            message='مرحباً! 👋🏼 كيف نساعدك?'
            companyName='الصقر كلين'
            sendButton='ارسال'
          />
        </Box>
      </Layout>
    </StickyProvider>
  </>
  );
}

const styles = {
  widget: {
    box: {
      position: 'fixed',
      zIndex: '9999',
      bottom: 0,
      right: '-1rem',
      a: {
        bottom: '104px',
      }
    },
  },
};
